<div id="selection-main-content" class="modal notification-modal" tabindex="-1" role="dialog" *ngIf="activateModal">
    <div class="modal-dialog selection-modal" role="document">
        <button type="button" class="close" (click)="closeModal()" data-dismiss="modal" aria-label="Close"></button>
        <div class="modal-content">
            <div class="modal-body">

                <div class="container-fluid {{ format }}-view">

                    <div class="row">
                        <div class="row col-xs-7 col-lg-7 col-sm-9 selection-content">
                            <div class="heading">Selection Report | {{learnerName}}</div>
                            <div class="row print-col-section">
                                <button class="selection-print-btn float-sm-right col-xs-10"
                                        (click)="printReport()">
                                </button>
                            </div>
                            <div class="sub-heading selection-completed-date">Completed {{ report?.selectionReportDate }}</div>
                        </div>
                        <div class="row selection-contents col-lg-12 col-sm-12">
                            <div class="selection-book">
                                <div class="selection-book-cover">
                                    <img class="selection-book-cover-image" src="{{getSelectedBookCoverImage()}}">
                                    <div class="col-xs-7 selection-book-title">{{ report?.storyDescription?.fullTitle }}</div>
                                </div>
                                <div class="col-xs-8 message-block">
                                    <div class="message-group">
                                        <div [ngClass]="getRecordingStatusImg()"></div>
                                        <span class="message" [innerHTML]="getRecordingStatusText()"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row selection-report-area">
                        <div class="selection-chart-col col-sm-12 col-lg-7">
                            <div class="section-header">
                                <span class="hidden-lg-up">My Points</span>
                            </div>
                            <div class="selection-chart-area border-box">

                                <div class="row points-row" id="total-header">
                                    <div class="row col-xs-2 col-lg-1 selection-step-buffer"></div>
                                    <div class="row col-xs-3 col-lg-4 pr-0">
                                        <div class="points-heading">Total Points Earned:</div>
                                    </div>
                                    <div class="col-xs-2 col-lg-3 selection-step-chart"></div>
                                    <div class="col-xs-3 col-md-4 selection-step-info-maxpoints" [ngClass]="maxPointsBufferNeeded()">
                                        <div class="points-ratio total-points-ratio">{{earnedPoint}}/{{maxPoint}}</div>
                                        <div class="max-points-text">Max Points</div>
                                    </div>
                                    <div class="col-xs-2 col-lg-1"></div>
                                    <div class="selection-total-line"></div>
                                </div>

                                <div class="row points-row" *ngIf="quiz" id="quiz">
                                    <div class="row col-xs-2 col-lg-1 selection-step-buffer"></div>
                                    <div class="col-xs-3 col-lg-4 pr-0 selection-step-info">
                                        <div class="points-heading">Step 3: Quiz</div>
                                        <div class="points-sub-heading">{{quiz.highestScore}}</div>
                                        <!--<div class="points-sub-heading">{{quiz.currentScore}}</div>-->
                                    </div>
                                    <div class="col-xs-2 col-lg-3 selection-step-chart">
                                        <div class="col-xs-12 bar-overlay-parent">
                                            <div class="bar-bottom bar-bottom-quiz"></div>
                                            <div class="bar-top-quiz" [ngStyle]="getBarFill('quiz')"  [ngClass]="{'bar-top-quiz-completed' : quiz.hasStar}"></div>
                                            <div [ngClass]="getQuizImg()"></div>
                                        </div>

                                    </div>
                                    <div class="col-xs-3 col-md-4 step-points-ratio" [ngClass]="maxPointsBufferNeeded()">
                                        <div class="step1-points-ratio">{{quiz.point}}/{{quiz.goal}}</div>
                                        <div class="max-points-text">Max Points</div>
                                    </div>
                                    <div class="col-xs-2 col-lg-1"></div>
                                </div>
                                <div class="row points-row" *ngIf="fluency" id="fluency">
                                    <div class="row col-xs-2 col-lg-1 selection-step-buffer"></div>
                                    <div class="col-xs-3 col-lg-4 pr-0 selection-step-info">
                                        <div class="points-heading">Step 2: Read & Record</div>
                                        <div class="points-sub-heading">{{fluency.highestWCPM}}<br/>{{fluency.wcpmTarget}}</div>
                                    </div>
                                    <div class="col-xs-2 col-lg-3 selection-step-chart">
                                        <div class="col-xs-12 bar-overlay-parent">
                                            <div class="bar-bottom bar-bottom-fluency"></div>
                                            <div class="bar-top-fluency" [ngStyle]="getBarFill('fluency')"></div>
                                            <div [ngClass]="getFluencyImg()"></div>
                                        </div>

                                    </div>
                                    <div class="col-xs-3 col-md-4 step-points-ratio" [ngClass]="maxPointsBufferNeeded()">
                                        <div class="step2-points-ratio">{{fluency.point}}/{{fluency.goal}}</div>
                                        <div class="max-points-text">Max Points</div>
                                    </div>
                                    <div class="col-xs-2 col-lg-1"></div>
                                </div>
                                <div class="row points-row" *ngIf="preview" id="preview">
                                    <div class="row col-xs-2 col-lg-1 selection-step-buffer"></div>
                                    <div class="col-xs-3 col-lg-4 pr-0 selection-step-info">
                                        <div class="points-heading">Step 1: Preview & Read</div>
                                        <div class="points-sub-heading">{{preview.highestScore}}</div>
                                    </div>
                                    <div class="col-xs-2 col-lg-3 pr-0 selection-step-chart">
                                        <div class="col-xs-12 bar-overlay-parent">
                                            <div class="bar-bottom bar-bottom-preview"></div>
                                            <div class="bar-top-preview" [ngStyle]="getBarFill('preview')"></div>
                                            <div [ngClass]="getPreviewImg()"></div>
                                        </div>
                                        <div class="bar-bottom-base"></div>
                                    </div>
                                    <div class="col-xs-3 col-md-4 step-points-ratio" [ngClass]="maxPointsBufferNeeded()">
                                        <div class="step3-points-ratio">{{preview.point}}/{{preview.goal}}</div>
                                        <div class="max-points-text">Max Points</div>
                                    </div>
                                    <div class="base"></div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="selection-words-col col-sm-12 col-lg-3 no-gutter">
                            <div class="section-header-word-practice">
                                <span>Words to Practice</span>
                            </div>
                            <div class="words-practice">

                                <ul class="list-group hidden-md-down">
                                    <li *ngFor="let word of getReviewWords()"
                                        class="list-group-item word-item">
                                        <span *ngIf="!!word"
                                              class="{{word.wordColor}}"
                                              [innerHTML]="word.word"
                                              ng-show="word.word"></span>

                                    </li>
                                </ul>

                                <div class="selection-portrait-words-tables row">
                                    <div *ngFor="let tableList of reviewWordsRange; let tidx = index"
                                         class="col-xs-4">
                                        <ul class="list-group">
                                            <li *ngFor="let word of getReviewWordsTable(tidx, report?.fluency?.reviewWords);"
                                                class="list-group-item word-item">
                                                    <span *ngIf="!!word"
                                                          [innerHTML]="word.word"
                                                          class="{{word.wordColor}}">
                                                </span>
                                            </li>
                                        </ul>

                                    </div>
                                </div>
                                <span class="shadow"></span>

                            </div>
                        </div>  <!--words to practice-->

                    </div>
                </div>    <!--container-->
            </div>  <!--modal-body-->
        </div>  <!--modal-content-->
    </div>  <!--modal-dialog-->
</div>   <!--notification-modal-->

<div class="modal-backdrop fade in" *ngIf="activateModal"></div>
